module.exports = __webpack_public_path__ + "static/44import-00978518ac59f674aebf65009da9cbeb.png";